import { gql, TypedDocumentNode } from "@apollo/client";

import type {
  AuthorizationScheme,
  InputMaybe,
  Maybe,
  OAuthRedirect,
  SlackAppConfig,
  SlackEnvironment,
  SlackIntegration,
} from "types/generated";

type SettingsSlackIntegration = Maybe<Pick<SlackIntegration, "teamName" | "teamID">>;
export type SettingsSlackAppConfig = Maybe<Pick<SlackAppConfig, "clientId" | "canUpdate">>;

type FetchGetAccountIntegrations = {
  authorizationScheme: AuthorizationScheme;
  slackIntegration: SettingsSlackIntegration;
  slackAppConfig: SettingsSlackAppConfig;
};

export const GET_ACCOUNT_INTEGRATIONS: TypedDocumentNode<FetchGetAccountIntegrations> = gql`
  query GetAccountIntegrations($isSelfHosted: Boolean!) {
    authorizationScheme
    slackIntegration {
      teamName
      teamID
    }
    slackAppConfig @include(if: $isSelfHosted) {
      clientId
      canUpdate
    }
  }
`;

type FetchSlackOauthRedirect = {
  slackOauthRedirect: Pick<OAuthRedirect, "providerUrl" | "temporaryToken">;
};

type SlackOauthRedirectVariables = {
  slackEnvironment?: InputMaybe<SlackEnvironment>;
};

export const SLACK_OAUTH_REDIRECT: TypedDocumentNode<
  FetchSlackOauthRedirect,
  SlackOauthRedirectVariables
> = gql`
  mutation SlackOauthRedirect($slackEnvironment: SlackEnvironment) {
    slackOauthRedirect(slackEnvironment: $slackEnvironment) {
      providerUrl
      temporaryToken
    }
  }
`;
